import {
  ICloseTabRequest,
  ICloseTabContract,
  ICloseTabResponse,
  ICloseTabBodyPayload,
} from "./types";
import { IRepoErrors } from "@/v2/repo/errors";
import { AxiosResponse } from "axios";
import { http } from "../../http";

export class CloseTabError extends Error {
  errors: IRepoErrors;

  constructor(errors: IRepoErrors) {
    super("Error in repo: CloseTab");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

export async function closeTab(
  request: ICloseTabRequest
): Promise<ICloseTabResponse> {
  let response: AxiosResponse<ICloseTabContract>;

  let params: ICloseTabBodyPayload = {
    outlet_id: request.outletId,
  };

  if (request.pin && request.reason) {
    params = {
      ...params,
      pin: request.pin,
      reason: request.reason,
    };
  }

  try {
    response = await http.put(
      `api/v3/businesses/${request.businessId}/tabs/${request.tabId}/close`,
      { ...params }
    );
  } catch (e: any) {
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    const customError = e?.response?.data?.error;
    if (customError) {
      e.errorCode = customError?.code;
    }

    throw new CloseTabError(e);
  }

  return {
    outletId: response.data.outlet_id,
  };
}
